export default "__VITE_ASSET__xoSbcGhu__"